import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollTrigger } from '../animations/registerGsap';
import { flushScrollToTop } from '../utils/scrollLock';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    flushScrollToTop();
    requestAnimationFrame(() => ScrollTrigger.refresh());
  }, [pathname]);

  useEffect(() => {
    flushScrollToTop();
  }, []);

  return null;
};

export default ScrollToTop;
